module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 215);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  1:
  /***/
  function _(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  11:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    exports.default = Link;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _bind = __webpack_require__(3);

    var _bind2 = _interopRequireDefault(_bind);

    var _general = __webpack_require__(28);

    var _general2 = _interopRequireDefault(_general);

    var _state = __webpack_require__(29);

    var _state2 = _interopRequireDefault(_state);

    var _type = __webpack_require__(30);

    var _type2 = _interopRequireDefault(_type);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var cx = _bind2.default.bind(_extends({}, _general2.default, _state2.default, _type2.default));

    function Link(_ref) {
      var _cx;

      var alt = _ref.alt,
          block = _ref.block,
          children = _ref.children,
          hasUnderline = _ref.hasUnderline,
          id = _ref.id,
          isActive = _ref.isActive,
          isDisabled = _ref.isDisabled,
          onClick = _ref.onClick,
          tabIndex = _ref.tabIndex,
          target = _ref.target,
          title = _ref.title,
          type = _ref.type,
          url = _ref.url,
          dataBypass = _ref['data-bypass'];
      var linkClasses = cx('link', (_cx = {}, _defineProperty(_cx, type + '-isActive', isActive && !isDisabled), _defineProperty(_cx, type + '-hasUnderline', hasUnderline), _defineProperty(_cx, type + '-isDisabled', isDisabled), _defineProperty(_cx, type, !isActive && !isDisabled), _defineProperty(_cx, 'display-block', block), _defineProperty(_cx, 'display-inlineBlock', !block), _defineProperty(_cx, 'isDisabled', isDisabled), _cx));
      var linkProps = {
        alt: alt,
        className: linkClasses,
        id: id,
        onClick: onClick,
        title: title,
        tabIndex: tabIndex
      };

      if (dataBypass) {
        linkProps['data-bypass'] = true;
      }

      if (url) {
        return _react2.default.createElement('a', _extends({}, linkProps, {
          target: target,
          href: url
        }), children);
      }

      return _react2.default.createElement('span', linkProps, children);
    }

    Link.propTypes = {
      alt: _propTypes2.default.string,
      block: _propTypes2.default.bool,
      children: _propTypes2.default.node,
      hasUnderline: _propTypes2.default.bool,
      id: _propTypes2.default.string,
      isActive: _propTypes2.default.bool,
      isDisabled: _propTypes2.default.bool,
      onClick: _propTypes2.default.func,
      tabIndex: _propTypes2.default.number,
      target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
      title: _propTypes2.default.string,
      type: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired,
      url: _propTypes2.default.string,
      'data-bypass': _propTypes2.default.bool
    };
    Link.defaultProps = {
      block: false,
      hasUnderline: false,
      isActive: false,
      type: 'light'
    };
    /***/
  },

  /***/
  2:
  /***/
  function _(module, exports) {
    module.exports = require("classnames");
    /***/
  },

  /***/
  215:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.PopoverOption = undefined;

    var _PopoverOption = __webpack_require__(216);

    Object.defineProperty(exports, 'PopoverOption', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_PopoverOption).default;
      }
    });

    var _Popover = __webpack_require__(219);

    var _Popover2 = _interopRequireDefault(_Popover);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    exports.default = _Popover2.default;
    /***/
  },

  /***/
  216:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = PopoverOption;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _bind = __webpack_require__(3);

    var _bind2 = _interopRequireDefault(_bind);

    var _Link = __webpack_require__(11);

    var _Link2 = _interopRequireDefault(_Link);

    var _general = __webpack_require__(217);

    var _general2 = _interopRequireDefault(_general);

    var _size = __webpack_require__(218);

    var _size2 = _interopRequireDefault(_size);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    var cx = _bind2.default.bind(_size2.default);

    function PopoverOption(_ref) {
      var _cx;

      var children = _ref.children,
          isSep = _ref.isSep,
          size = _ref.size,
          props = _objectWithoutProperties(_ref, ['children', 'isSep', 'size']);

      var classes = cx((_cx = {}, _defineProperty(_cx, _general2.default.option, !isSep), _defineProperty(_cx, _general2.default.sep, isSep), _defineProperty(_cx, size, !isSep), _cx));
      return _react2.default.createElement('span', {
        className: classes
      }, !isSep && _react2.default.createElement(_Link2.default, props, children));
    }

    PopoverOption.propTypes = {
      children: _propTypes2.default.node,
      isSep: _propTypes2.default.bool,
      size: _propTypes2.default.oneOf(Object.keys(_size2.default))
    };
    PopoverOption.defaultProps = {
      children: null,
      isSep: false,
      type: 'lightBlue',
      size: 'medium'
    };
    /***/
  },

  /***/
  217:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "option": "general__option___259gy c-marvel--hover c-slate display-block fontSize-m lineHeight-xs",
      "sep": "general__sep___3hjFE bg-smoke display-block width-100"
    };
    /***/
  },

  /***/
  218:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "extraSmall": "size__extraSmall___ezHyG margin-xs",
      "small": "size__small___27OWA margin-s",
      "medium": "size__medium___1ao60 margin-m"
    };
    /***/
  },

  /***/
  219:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _find = __webpack_require__(38);

    var _find2 = _interopRequireDefault(_find);

    var _classnames = __webpack_require__(2);

    var _classnames2 = _interopRequireDefault(_classnames);

    var _exenv = __webpack_require__(220);

    var _Wrap = __webpack_require__(221);

    var _Wrap2 = _interopRequireDefault(_Wrap);

    var _general = __webpack_require__(69);

    var _general2 = _interopRequireDefault(_general);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Popover = function (_Component) {
      _inherits(Popover, _Component);

      function Popover() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Popover);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          isClicked: false,
          isHovered: false
        }, _this.onClick = function () {
          _this.setState({
            isClicked: !_this.state.isClicked
          });
        }, _this.mouseEnter = function () {
          // 'this.hasMousePreviouslyEntered' guards against multiple mouse enter
          // events being fired before state is updated. As setState is asynchronous,
          // we can't rely solely on state to check if the mouse event has been fired
          // and need an additional property to track this.
          if (!_this.state.isHovered && !_this.hasMousePreviouslyEntered) {
            _this.hasMousePreviouslyEntered = true;
            var delay = _this.props.delay;

            if (delay && !_this.timer) {
              _this.timer = setTimeout(_this.setHoveredState, delay);
            } else {
              _this.setHoveredState();
            }
          }
        }, _this.setHoveredState = function () {
          _this.setState({
            isHovered: true
          });
        }, _this.mouseLeave = function () {
          _this.hasMousePreviouslyEntered = false;
          clearTimeout(_this.timer);
          _this.timer = null;

          _this.setState({
            isHovered: false
          });
        }, _this.handleOutsideClick = function (event) {
          if (!_this.state.isClicked) {
            return;
          }

          if (_this.node.contains(event.target)) {
            return;
          }

          _this.setState({
            isClicked: false
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(Popover, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          if (_exenv.canUseDom) {
            document.addEventListener('click', this.handleOutsideClick, false);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.timer);

          if (_exenv.canUseDom) {
            document.removeEventListener('click', this.handleOutsideClick, false);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var _state = this.state,
              isClicked = _state.isClicked,
              isHovered = _state.isHovered;
          var _props = this.props,
              children = _props.children,
              isDisabled = _props.isDisabled,
              showOnHover = _props.showOnHover,
              triggerFullWidth = _props.triggerFullWidth;
          var popoverClasses = (0, _classnames2.default)(_general2.default.trigger, {
            'width-100': triggerFullWidth
          });
          var popoverProps = {
            className: popoverClasses,
            ref: function ref(node) {
              _this2.node = node;
            }
          };

          if (!isDisabled) {
            if (showOnHover) {
              popoverProps.onMouseEnter = this.mouseEnter;
              popoverProps.onMouseLeave = this.mouseLeave;
            } else {
              popoverProps.onClick = this.onClick;
            }
          }

          var isActive = showOnHover ? isHovered : isClicked;
          var trigger = findChild(children, function (child) {
            return child.type === Popover.Trigger;
          });
          var content = findChild(children, function (child) {
            return child.type === Popover.Content;
          });

          if (!content) {
            return _react2.default.createElement(_Wrap2.default, this.props, children);
          }

          return _react2.default.createElement('div', popoverProps, trigger, _react2.default.createElement(_Wrap2.default, _extends({
            isActive: isActive
          }, this.props), content));
        }
      }]);

      return Popover;
    }(_react.Component);

    exports.default = Popover;

    Popover.Trigger = function (_ref2) {
      var children = _ref2.children;
      return children;
    };

    Popover.Content = function (_ref3) {
      var children = _ref3.children;
      return children;
    };

    Popover.propTypes = {
      children: _propTypes2.default.node.isRequired,
      delay: _propTypes2.default.number,
      isDisabled: _propTypes2.default.bool,
      triggerFullWidth: _propTypes2.default.bool,
      showOnHover: _propTypes2.default.bool
    };
    Popover.defaultProps = {
      delay: 0,
      isDisabled: false,
      triggerFullWidth: false,
      showOnHover: false
    };

    function findChild(children, predicate) {
      return (0, _find2.default)(_react.Children.toArray(children), predicate);
    }
    /***/

  },

  /***/
  220:
  /***/
  function _(module, exports) {
    module.exports = require("exenv");
    /***/
  },

  /***/
  221:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    exports.default = Wrap;

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _bind = __webpack_require__(3);

    var _bind2 = _interopRequireDefault(_bind);

    var _Caret = __webpack_require__(222);

    var _Caret2 = _interopRequireDefault(_Caret);

    var _general = __webpack_require__(69);

    var _general2 = _interopRequireDefault(_general);

    var _position = __webpack_require__(227);

    var _position2 = _interopRequireDefault(_position);

    var _size = __webpack_require__(228);

    var _size2 = _interopRequireDefault(_size);

    var _type = __webpack_require__(229);

    var _type2 = _interopRequireDefault(_type);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var cx = _bind2.default.bind(_extends({}, _general2.default, _position2.default, _size2.default, _type2.default));

    var positionMargin = {
      top: 'marginBottom',
      right: 'marginLeft',
      bottom: 'marginTop',
      left: 'marginRight'
    };
    var offsetMargin = {
      top: 'marginTop',
      right: 'marginRight',
      bottom: 'marginBottom',
      left: 'marginLeft',
      center: 'marginLeft'
    };
    var popoverMargins = {
      small: 10,
      medium: 15,
      large: 20
    };

    function Wrap(_ref) {
      var _cx, _style;

      var align = _ref.align,
          caretOffset = _ref.caretOffset,
          children = _ref.children,
          hasAnimation = _ref.hasAnimation,
          hasCaret = _ref.hasCaret,
          height = _ref.height,
          isActive = _ref.isActive,
          margin = _ref.margin,
          maxWidth = _ref.maxWidth,
          minWidth = _ref.minWidth,
          offset = _ref.offset,
          position = _ref.position,
          size = _ref.size,
          style = _ref.style,
          type = _ref.type,
          width = _ref.width; // Depreciated style prop

      if (process.env.NODE_ENV !== 'production' && style && !Wrap.didWarn) {
        Wrap.didWarn = true; // eslint-disable-next-line no-console

        console.warn('Warning: Popover.style is deprecated. Use Popover.type instead');
      }

      var spacing = margin || popoverMargins[size];
      var typeProp = style || type;
      var offsetDirection = align === 'center' ? {
        top: 'left',
        bottom: 'left',
        left: 'top',
        right: 'top'
      }[position] : align;
      var containerClasses = cx('popover', position + '-' + align, (_cx = {}, _defineProperty(_cx, position + '-' + align + '--isActive', isActive), _defineProperty(_cx, 'hasAnimation', hasAnimation), _cx));
      var containerProps = {
        className: containerClasses,
        style: (_style = {}, _defineProperty(_style, positionMargin[position], spacing), _defineProperty(_style, offsetMargin[offsetDirection], offset), _style)
      };
      var popoverStyles = {
        height: height,
        maxWidth: maxWidth,
        minWidth: minWidth,
        width: maxWidth ? 'auto' : width
      };
      var popoverProps = {
        className: cx(typeProp, size, 'inner'),
        style: popoverStyles
      };
      var overlayStyle = void 0;
      var overlayClasses = cx('overlay-' + position);

      switch (position) {
        case 'top':
          overlayStyle = {
            bottom: -spacing,
            height: spacing
          };
          break;

        case 'right':
          overlayStyle = {
            left: -spacing,
            width: spacing
          };
          break;

        case 'bottom':
          overlayStyle = {
            top: -spacing,
            height: spacing
          };
          break;

        case 'left':
          overlayStyle = {
            right: -spacing,
            width: spacing
          };
          break;

        default:
          overlayStyle = {};
      }

      return _react2.default.createElement('div', containerProps, _react2.default.createElement('div', {
        className: overlayClasses,
        style: overlayStyle
      }), _react2.default.createElement('div', popoverProps, children), hasCaret && _react2.default.createElement(_Caret2.default, {
        align: align,
        caretOffset: caretOffset,
        position: position,
        size: size,
        type: typeProp
      }));
    }

    Wrap.propTypes = {
      align: _propTypes2.default.oneOf(['bottom', 'center', 'left', 'right', 'top']),
      caretOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
      children: _propTypes2.default.node.isRequired,
      hasAnimation: _propTypes2.default.bool,
      hasCaret: _propTypes2.default.bool,
      height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
      // auto
      isActive: _propTypes2.default.bool,
      margin: _propTypes2.default.number,
      maxWidth: _propTypes2.default.number,
      minWidth: _propTypes2.default.number,
      offset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
      position: _propTypes2.default.oneOf(['bottom', 'left', 'right', 'top']),
      size: _propTypes2.default.oneOf(Object.keys(_size2.default)),
      style: _propTypes2.default.oneOf(Object.keys(_type2.default)),
      type: _propTypes2.default.oneOf(Object.keys(_type2.default)),
      width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
    };
    Wrap.defaultProps = {
      align: 'center',
      caretOffset: null,
      hasAnimation: true,
      hasCaret: true,
      height: null,
      isActive: false,
      margin: null,
      maxWidth: null,
      minWidth: null,
      offset: null,
      position: 'top',
      size: 'medium',
      type: 'default',
      width: null
    };
    /***/
  },

  /***/
  222:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    exports.default = Caret;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _bind = __webpack_require__(3);

    var _bind2 = _interopRequireDefault(_bind);

    var _general = __webpack_require__(223);

    var _general2 = _interopRequireDefault(_general);

    var _position = __webpack_require__(224);

    var _position2 = _interopRequireDefault(_position);

    var _size = __webpack_require__(225);

    var _size2 = _interopRequireDefault(_size);

    var _type = __webpack_require__(226);

    var _type2 = _interopRequireDefault(_type);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var caretSizes = {
      small: 8,
      medium: 10,
      large: 12
    };

    function Caret(_ref) {
      var align = _ref.align,
          caretOffset = _ref.caretOffset,
          position = _ref.position,
          size = _ref.size,
          type = _ref.type;

      var cx = _bind2.default.bind(_extends({}, _general2.default, _position2.default, _size2.default, _type2.default));

      var xaxis = position === 'left' || position === 'right';
      var yaxis = position === 'top' || position === 'bottom'; // The caret is created by rotating a simple square
      // and cutting it in half to hide the remaining shape

      var wrapStyles = {
        width: xaxis ? caretSizes[size] / 2 : caretSizes[size],
        height: xaxis ? caretSizes[size] : caretSizes[size] / 2
      };
      var wrapClasses = cx('wrap', position + '-' + align);
      var caretStyles = {
        width: caretSizes[size],
        height: caretSizes[size]
      };
      var caretClasses = cx('caret', 'caret--' + position, type, size);

      if (caretOffset && yaxis) {
        wrapStyles.left = caretOffset;
        wrapStyles.right = 'auto';
      } else if (caretOffset && xaxis) {
        wrapStyles.top = caretOffset;
        wrapStyles.bottom = 'auto';
      }

      return _react2.default.createElement('div', {
        className: wrapClasses,
        style: wrapStyles
      }, _react2.default.createElement('div', {
        className: caretClasses,
        style: caretStyles
      }));
    }

    Caret.propTypes = {
      align: _propTypes2.default.oneOf(['bottom', 'center', 'left', 'right', 'top']),
      caretOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
      position: _propTypes2.default.oneOf(['bottom', 'left', 'right', 'top']),
      type: _propTypes2.default.oneOf(Object.keys(_type2.default)),
      size: _propTypes2.default.oneOf(Object.keys(_size2.default))
    };
    Caret.defaultProps = {
      align: 'center',
      caretOffset: null,
      position: 'top',
      type: 'default'
    };
    /***/
  },

  /***/
  223:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "caret": "general__caret___3Jmm8 display-block position-absolute",
      "wrap": "general__wrap___23Awi position-absolute overflow-hidden",
      "caret--top": "general__caret--top___1kHYi",
      "caret--bottom": "general__caret--bottom___2afxL",
      "caret--left": "general__caret--left___-qUNv",
      "caret--right": "general__caret--right___3pjW1"
    };
    /***/
  },

  /***/
  224:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "top-left": "position__top-left___1LytG",
      "top-center": "position__top-center___2Z8Ln",
      "top-right": "position__top-right___TPqR6",
      "right-top": "position__right-top___3LA_l",
      "right-center": "position__right-center___27QXI",
      "right-bottom": "position__right-bottom___1kwiU",
      "bottom-right": "position__bottom-right___2R2cA",
      "bottom-center": "position__bottom-center___11HNA",
      "bottom-left": "position__bottom-left___1Ngs-",
      "left-bottom": "position__left-bottom___1auNL",
      "left-center": "position__left-center___2jx2_",
      "left-top": "position__left-top___bP6Ac"
    };
    /***/
  },

  /***/
  225:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "small": "size__small___7BAwd",
      "medium": "size__medium___1fmU-",
      "large": "size__large___2liM- borderRadius-s"
    };
    /***/
  },

  /***/
  226:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "default": "type__default___1apsP bg-white boxShadow-subtle",
      "error": "type__error___3_b7R bg-negative",
      "dark": "type__dark___1JuD4 bg-black",
      "orange": "type__orange___2rtFX bg-orange"
    };
    /***/
  },

  /***/
  227:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "top-left": "position__top-left___3kXNg",
      "top-center": "position__top-center___1mN-2",
      "top-right": "position__top-right___2Sdxa",
      "top-left--isActive": "position__top-left--isActive___1OxdR disclosed",
      "top-right--isActive": "position__top-right--isActive___1uShk disclosed",
      "top-center--isActive": "position__top-center--isActive___3QNeW disclosed",
      "right-top": "position__right-top___32xg5",
      "right-center": "position__right-center___2jYyo",
      "right-bottom": "position__right-bottom___FsEFk",
      "right-center--isActive": "position__right-center--isActive___J3fW6 disclosed",
      "right-top--isActive": "position__right-top--isActive___JnNJW disclosed",
      "right-bottom--isActive": "position__right-bottom--isActive___3Gvur disclosed",
      "bottom-right": "position__bottom-right___3Z8ID",
      "bottom-center": "position__bottom-center___2iocZ",
      "bottom-left": "position__bottom-left___o-n8l",
      "bottom-center--isActive": "position__bottom-center--isActive___12e9Z disclosed",
      "bottom-right--isActive": "position__bottom-right--isActive___1eTrl disclosed",
      "bottom-left--isActive": "position__bottom-left--isActive___3Alqz disclosed",
      "left-bottom": "position__left-bottom___13dcX",
      "left-center": "position__left-center___2oTL9",
      "left-top": "position__left-top___2xd8Q",
      "left-center--isActive": "position__left-center--isActive___u3cdy disclosed",
      "left-top--isActive": "position__left-top--isActive___149VZ disclosed",
      "left-bottom--isActive": "position__left-bottom--isActive___16f-4 disclosed",
      "overlay-top": "position__overlay-top___3XAxC position-absolute",
      "overlay-bottom": "position__overlay-bottom___3gXBR position-absolute",
      "overlay-left": "position__overlay-left___2PQcx position-absolute",
      "overlay-right": "position__overlay-right___e6GU2 position-absolute"
    };
    /***/
  },

  /***/
  228:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "small": "size__small___1Pb-d borderRadius-s",
      "medium": "size__medium___2vvOR borderRadius-m",
      "large": "size__large___2fwKU borderRadius-l"
    };
    /***/
  },

  /***/
  229:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "default": "type__default___1U7Tw bg-white boxShadow-subtle",
      "error": "type__error___1tbcL c-white bg-negative",
      "dark": "type__dark___2_2vT c-white bg-black",
      "orange": "type__orange___36vzC c-white bg-orange"
    };
    /***/
  },

  /***/
  28:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "link": "general__link___2uaDd cursor-pointer textDecoration-none transitionDuration-m transitionProperty-all transitionTimingFunction-linear",
      "isDisabled": "general__isDisabled___13hDh pointerEvents-none userSelect-none"
    };
    /***/
  },

  /***/
  29:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "light-isActive": "state__light-isActive___2naAu c-marvel c-blue--d--hover",
      "light-isDisabled": "state__light-isDisabled___3uVvv c-smoke--xd",
      "light-hasUnderline": "state__light-hasUnderline___2COHc underline underline--smoke--xd",
      "lightBlue-isActive": "state__lightBlue-isActive___hxX3- c-marvel c-blue--d--hover",
      "lightBlue-isDisabled": "state__lightBlue-isDisabled___2cpBs c-smoke--xd",
      "lightBlue-hasUnderline": "state__lightBlue-hasUnderline___UDm8k underline underline--smoke--xd",
      "lightReversed-isActive": "state__lightReversed-isActive___1sL3h c-white c-white--hover",
      "lightReversed-isDisabled": "state__lightReversed-isDisabled___1Bj6n c-smoke--xd",
      "lightReversed-hasUnderline": "state__lightReversed-hasUnderline___2ayte underline underline--silver",
      "dark-isActive": "state__dark-isActive___1sgHj c-marvel c-blue--d--hover",
      "dark-isDisabled": "state__dark-isDisabled___18Q5n c-silver",
      "dark-hasUnderline": "state__dark-hasUnderline___1_LJo underline underline--smoke--xd",
      "negative-isActive": "state__negative-isActive___WKEbm c-slate c-negative--hover",
      "negative-isDisabled": "state__negative-isDisabled___2sRV4 c-silver",
      "negative-hasUnderline": "state__negative-hasUnderline___1BO_G underline underline--smoke--xd",
      "blue-isActive": "state__blue-isActive___170NY c-blue c-blue--d--hover",
      "blue-isDisabled": "state__blue-isDisabled___gG9pF c-blue opacity-70",
      "blue-hasUnderline": "state__blue-hasUnderline___1m5Cl underline underline--marvel",
      "green-isActive": "state__green-isActive___Vz44X c-green c-green--d--hover",
      "green-isDisabled": "state__green-isDisabled___2AKVK c-green opacity-70",
      "green-hasUnderline": "state__green-hasUnderline___1vQxK underline underline--green",
      "orange-isActive": "state__orange-isActive___2UKHh c-orange c-orange--d--hover",
      "orange-isDisabled": "state__orange-isDisabled___1AwH0 c-orange opacity-70",
      "orange-hasUnderline": "state__orange-hasUnderline___3zfv4 underline underline--orange",
      "pink-isActive": "state__pink-isActive___5G3ZM c-pink c-pink--d--hover",
      "pink-isDisabled": "state__pink-isDisabled___2odiA c-pink opacity-70",
      "pink-hasUnderline": "state__pink-hasUnderline___ckiE9 underline underline--pink",
      "purple-isActive": "state__purple-isActive___mhiwL c-purple c-purple--d--hover",
      "purple-isDisabled": "state__purple-isDisabled___3gwaz c-purple opacity-70",
      "purple-hasUnderline": "state__purple-hasUnderline___2oQ_O underline underline--purple",
      "red-isActive": "state__red-isActive___3uyen c-red c-red--d--hover",
      "red-isDisabled": "state__red-isDisabled___11j6j c-red opacity-70",
      "red-hasUnderline": "state__red-hasUnderline___p1zDE underline underline--red",
      "opaque-isActive": "state__opaque-isActive___2hIwr c-white opacity-100 c-white--hover",
      "opaque-isDisabled": "state__opaque-isDisabled___HZWHM c-white opacity-40",
      "opaque-hasUnderline": "state__opaque-hasUnderline___11xok underline underline--white--transparent",
      "opaqueReversed-isActive": "state__opaqueReversed-isActive___WHruu c-marvel opacity-100 opacity-60--hover",
      "opaqueReversed-isDisabled": "state__opaqueReversed-isDisabled___15RMw c-white opacity-60",
      "opaqueReversed-hasUnderline": "state__opaqueReversed-hasUnderline___17gvm underline underline--white--transparent",
      "snowBg-isActive": "state__snowBg-isActive___ZDNsF c-slate bg-snow--hover bg-snow--d--hover",
      "snowBg-isDisabled": "state__snowBg-isDisabled___2gjHW c-silver",
      "snowBg-hasUnderline": "state__snowBg-hasUnderline___25VIF underline underline--smoke--xd"
    };
    /***/
  },

  /***/
  3:
  /***/
  function _(module, exports) {
    module.exports = require("classnames/bind");
    /***/
  },

  /***/
  30:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "light": "type__light___37Mus c-silver c-black--hover",
      "lightBlue": "type__lightBlue___1ONWN c-silver c-marvel--hover",
      "lightReversed": "type__lightReversed___1IV0P c-silver c-white--hover",
      "dark": "type__dark___3peZp c-slate c-black--hover",
      "darkToBlue": "type__darkToBlue___3basT c-slate c-marvel--hover",
      "negative": "type__negative___24MPh c-silver c-negative--hover",
      "negativeDark": "type__negativeDark___2Ay5p c-slate c-negative--hover",
      "blue": "type__blue___35MPc c-blue c-blue--d--hover",
      "green": "type__green___3gt26 c-green c-green--d--hover",
      "orange": "type__orange___3NsXR c-orange c-orange--d--hover",
      "pink": "type__pink___14B5c c-pink c-pink--d--hover",
      "purple": "type__purple___126TX c-purple c-purple--d--hover",
      "red": "type__red___1tbbY c-red c-red--d--hover",
      "opaque": "type__opaque___3NJPL c-white breakPointM-opacity-60 opacity-100--hover",
      "opaqueReversed": "type__opaqueReversed___xfBCt c-white opacity-100 opacity-60--hover",
      "snowBg": "type__snowBg___1ziSR c-slate bg-snow--hover"
    };
    /***/
  },

  /***/
  38:
  /***/
  function _(module, exports) {
    module.exports = require("lodash/find");
    /***/
  },

  /***/
  69:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "popover": "general__popover___3gD5F concealed position-absolute zi-chrome",
      "hasAnimation": "general__hasAnimation___BRh6O transitionDuration-l transitionTimingFunction-cv-easeInOutBack",
      "inner": "general__inner___2-3W9",
      "trigger": "general__trigger___1J8k1 display-inlineBlock position-relative"
    };
    /***/
  }
  /******/

});